export const taskCenterTrackingIds = {
  topBarButton: 'task-center-top-bar-button',
};
